export var ConditionOperators = {
    equal: "eq",
    notEqual: "ne",
    lessThan: "lt",
    greaterThan: "gt",
    lessOrEqual: "lte",
    greaterOrEqual: "gte",
    include: "in",
    notInclude: "nin",
};
